import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Box, Grid } from '@dhl-ui/components'
import { BackButton } from '~/temp-ds-component/BackButton'

import {
  BusinessUnitMappingsCard,
  BusinessUnitsCard,
  DetailsCard,
  RoleMappingsCard,
  RolesCard,
} from '~/modules/adminusers/components'
import { links } from '~/AppRoutes'
import { useKeyCloakUser } from '~/modules/adminusers/hooks'
import { AdminBillingUnitsCard } from '~/modules/adminusers/components/AdminBillingUnitsCard'
import { useCurrentUser } from '~/common'

type Params = {
  userId: string
}

export const AdminDetailsPage = () => {
  const navigate = useNavigate()
  const { userId = '' } = useParams<Params>()
  const { t } = useTranslation()
  const { isCCC: isCccCurrentUser } = useCurrentUser()

  const [isEditingRole, setIsEditingRole] = useState<boolean>(false)
  const [isEditingBusinessUnit, setIsEditingBusinessUnit] = useState<boolean>(false)
  const { user, userRoleCategories, userRoles, userBusinessUnits, refetch } = useKeyCloakUser(userId)
  const userHasCccBusinessUnit = (userBusinessUnits ?? []).includes('ccc')

  const onBack = () => {
    navigate(links.usersLink())
  }

  if (!user || !userRoleCategories || !userRoles || !userBusinessUnits) {
    return null
  }

  return (
    <>
      <Grid>
        <Box marginBottom={2}>
          <BackButton onClick={() => onBack()}>{t('admin.adminUsersPage.userForm.backButtonTitle')}</BackButton>
        </Box>
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Grid container direction="column" spacing={2}>
            {userId && (
              <Grid>
                <DetailsCard user={user} />
              </Grid>
            )}
            {userHasCccBusinessUnit && isCccCurrentUser && (
              <Grid>
                <AdminBillingUnitsCard adminUserId={userId} adminUserName={`${user.firstName} ${user.lastName}`} />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Grid container direction="column" spacing={2}>
            {userId && (
              <Grid>
                {isEditingRole ? (
                  <RoleMappingsCard
                    userId={userId}
                    userRoles={userRoles}
                    userBusinessUnits={userBusinessUnits}
                    onBack={() => setIsEditingRole(false)}
                    onRefetch={refetch}
                  />
                ) : (
                  <RolesCard userRoleCategories={userRoleCategories} onEditClick={() => setIsEditingRole(true)} />
                )}
              </Grid>
            )}
            {userId && (
              <Grid>
                {isEditingBusinessUnit ? (
                  <BusinessUnitMappingsCard
                    userId={userId}
                    userRoles={userRoles}
                    userBusinessUnits={userBusinessUnits}
                    onBack={() => setIsEditingBusinessUnit(false)}
                    onRefetch={refetch}
                  />
                ) : (
                  <BusinessUnitsCard
                    userBusinessUnits={userBusinessUnits}
                    onEditClick={() => setIsEditingBusinessUnit(true)}
                  />
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
